import { EffectReducer } from 'use-effect-reducer'
import {
  LSPAYCnpPmofPaymentEffect,
  LSPAYCnpPmofPaymentEvent,
  LSPAYCnpPmofPaymentState,
} from './types'

export const cnpPmofPaymentStateReducer: EffectReducer<
  LSPAYCnpPmofPaymentState,
  LSPAYCnpPmofPaymentEvent,
  LSPAYCnpPmofPaymentEffect
> = (state, event, exec) => {
  switch (event.type) {
    case 'SESSION_CREATED':
      if (state.status !== 'creatingSession') return state

      return {
        status: 'collectingCardDetails',
        session: event.session,
        paymentId: event.paymentId,
      }
    case 'FORM_SUBMISSION_COMPLETE':
      if (state.status !== 'collectingCardDetails') return state

      exec({ type: 'confirmPaymentStateEffect' })
      return {
        status: 'confirmingPaymentState',
        paymentId: state.paymentId,
      }
    case 'API_STATE_VERIFIED':
      if (state.status !== 'confirmingPaymentState') return state

      return {
        status: 'done',
        transaction: event.transaction,
      }
    case 'RETRY_CONFIRMING':
      if (
        state.status !== 'confirmingPaymentState' &&
        state.status !== 'confirmingPaymentStateTimeout'
      ) {
        return state
      }

      exec({ type: 'confirmPaymentStateEffect', context: event.context })
      return {
        ...state,
        status: 'confirmingPaymentState',
      }
    case 'CONFIRM_PAYMENT_STATE_TIMEOUT':
      if (state.status !== 'confirmingPaymentState') return state

      return {
        status: 'confirmingPaymentStateTimeout',
        paymentId: state.paymentId,
      }
    case 'RESTART_WORKFLOW':
      exec({ type: 'createSessionEffect' })
      return {
        status: 'creatingSession',
      }
    case 'ERROR':
      return {
        status: 'error',
        errorMessage: event.errorMessage,
        previousState: state,
      }
    default: {
      // This `never` typing will let us know at compile time if we do not handle an existing event type. Neat !
      const _exhaustiveCheck: never = event
      return _exhaustiveCheck
    }
  }
}
